import { UserDto } from '@act/shared/data-transfer-objects';

export function getNormalizedGender(member: UserDto): string {
  if (!member?.gender) return 'Unknown';

  if (['m', 'male'].includes(member?.gender.toLocaleLowerCase())) {
    return 'Male';
  } else if (['f', 'female'].includes(member?.gender.toLocaleLowerCase())) {
    return 'Female';
  } else {
    return 'Unknown';
  }
}
